import BaseForm from "../form";
import StandCollectionsApi from "../../api/references/standcollections";

class StandCollectionForm extends BaseForm {
    doSave = (item) => {
        const payload = {...item}
        delete payload.products

        StandCollectionsApi.save(payload).then(result => {
            const {data} = result
            if (data.id) {
                window.postMessage({type: this.props.eventType, value: data})
                window.postMessage({
                    type: 'success',
                    text: 'Данные сохранены',
                    timeout: 1500,
                    hideSpinner: true
                })
            }
        }).catch(error => {
            window.postMessage({
                type: 'error',
                text: error?.response?.data?.error || 'Не удалось сохранить коллекцию',
                timeout: 3000,
                hideSpinner: true
            })
        })
    }
}

export default StandCollectionForm
